import { catalogs, fallbackLocale } from './catalogs.js';
import type { Locale, TranslationKey, TranslationParams } from './types.js';

const interpolationPattern = /\{\{(\w+)\}\}/g;

function lookup(catalog: unknown, key: string): string | undefined {
  const parts = key.split('.');
  let current: unknown = catalog;

  for (const part of parts) {
    if (typeof current !== 'object' || current === null) {
      return undefined;
    }

    current = (current as Record<string, unknown>)[part];
  }

  return typeof current === 'string' ? current : undefined;
}

function interpolate(template: string, params?: TranslationParams): string {
  if (!params) {
    return template;
  }

  return template.replace(interpolationPattern, (match, key: string) => {
    const value = params[key];
    return value === undefined ? match : String(value);
  });
}

export function translate(locale: Locale, key: TranslationKey, params?: TranslationParams): string {
  const primary = lookup(catalogs[locale], key);
  if (primary !== undefined) {
    return interpolate(primary, params);
  }

  const fallback = lookup(catalogs[fallbackLocale], key);
  if (fallback !== undefined) {
    return interpolate(fallback, params);
  }

  return key;
}

export function createTranslator(
  locale: Locale,
): (key: TranslationKey, params?: TranslationParams) => string {
  return (key, params) => translate(locale, key, params);
}
